import { TReduxActions } from '../../../types/redux';
import { EAnonymousActionTypes } from '../../../actions/newQuestion/isAnonymousActions';
import { ENewQuestionForm } from '../../../actions/newQuestion';

export const defaultValue = null;

export function isAnonymousReducer(
  state: boolean | null = defaultValue,
  { type, payload }: TReduxActions,
): boolean | null {
  if (type === EAnonymousActionTypes.Set) {
    return payload;
  }

  if (type === ENewQuestionForm.Clear) {
    return defaultValue;
  }

  return state;
}
